export const formatToBRL = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export const formatToUF = (value: number, exibirPrefixo = true) => {
  return (
    (exibirPrefixo ? 'UF ' : '') +
    new Intl.NumberFormat('es-CL', {
      style: 'decimal',
      minimumFractionDigits: 2,
    }).format(value)
  )
}

export const formatToCLP = (value: number) => {
  return (
    '$ ' +
    new Intl.NumberFormat('es-CL', {
      style: 'decimal',
      minimumFractionDigits: 2,
    }).format(value)
  )
}
